import { render, staticRenderFns } from "./widgetDetailsModal.vue?vue&type=template&id=829bbf2c&scoped=true"
import script from "./widgetDetailsModal.vue?vue&type=script&lang=js"
export * from "./widgetDetailsModal.vue?vue&type=script&lang=js"
import style0 from "./widgetDetailsModal.vue?vue&type=style&index=0&id=829bbf2c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "829bbf2c",
  null
  
)

export default component.exports